<div class="financial-health-feature">
  <mfp-circular-indicator
    class="feature__indicator"
    [basePercentage]="base"
    [currentPercentage]="current"
  ></mfp-circular-indicator>
  <div class="financial-health-feature__col">
    <div class="financial-health-feature__content">
      <h2 class="content__title">{{ title }}</h2>
      <p class="content__description">{{ description }}</p>
    </div>
    <ng-content></ng-content>
  </div>
</div>
